import { render } from "./sortingPage.vue?vue&type=template&id=8aae8f9a"
import script from "./sortingPage.vue?vue&type=script&lang=js"
export * from "./sortingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__